import { Observable } from "rxjs";

/** Art der zustellung des Gutscheins */
export enum DeliverySetting {
  /** versand erfolgt per Mail */
  Mail,
  /** versand erfolgt per Post */
  Post,
  /** Mail und Post verasand sind möglich */
  MailOrPost
}

export interface IWebVoucherCustomDetailService {
  /* initial vorbesetzter Preis, muss gefüllt werden */
  readonly NO_PRICE: number;
  /* min. Grenzwert für den Preis */
  readonly MIN_PRICE: number;
  /* max. Grenzwert für den Preis */
  readonly MAX_PRICE: number;
  /* min. Grenzwert für die Anzahl */
  readonly MIN_COUNT: number;
  /* max. Grenzwert für die Anzahl */
  readonly MAX_COUNT: number;
  /* min. Grenzwert für die Anzahl der Personen */
  readonly MIN_PERSON_COUNT: number;
  /* max. Grenzwert für die Anzahl der Personen */
  readonly MAX_PERSON_COUNT: number;
  /** webVoucher */
  readonly webVoucher$: Observable<IWebVoucher>;
  /** webVoucher settings */
  readonly webVoucher_settings$: Observable<IWebVoucherSettings>;
  /** initialisierung aller notwendigen daten, mit benötigten Webgutschein */
  init(webvoucherID: number): Promise<void>;
  /** Preis für Gutschein */
  readonly price$: Observable<number>;
  /** änderung des freien Preises für den Gutschein */
  changePrice(price: number): void;
  /** Anzahl der Personen */
  readonly personCount$: Observable<number>;
  /** erhöht die Anzahl der Personen */
  incrementPersonCount(): void;
  /** verringert die Anzahl der Personen */
  decrementPersonCount(): void;
  /** änderung der Anzahl der Personen für den Gutschein */
  changePersonCount(personCount: number): void;
  /** art des versands */
  readonly deliveryType$: Observable<DeliverySetting>;
  /** änderung der versandart */
  changeDeliveryType(deliveryType: DeliverySetting.Mail | DeliverySetting.Post): void;
  /** Anzahl der Webgutscheine */
  readonly count$: Observable<number>;
  /** erhöht die Anzahl der Webgutscheine */
  incrementCount(): void;
  /** verringert die Anzahl der Webgutscheine */
  decrementCount(): void;
  /** änderung der Anzahl für den Gutschein */
  changeCount(count: number): void;
  /** zu zahlender Betrag */
  readonly sum$: Observable<number>;
  /** fügt den Gutschein dem Warenkorb hinzu */
  addToBasket(): Promise<void>;
}

export interface IWebVoucherSettings {
  /** number of persons can be selected */
  readonly useNumber_of_Persons: boolean;
  /**delivery options Post or Email / only Post / only Email*/
  readonly delivery_settings: DeliverySetting;
  /** delivery cost */
  readonly delivery_costs: number;
}

export interface IWebVoucher {
  /** webVoucher id */
  readonly id: number;
  /** webVoucher has img */
  readonly hasImage: boolean;
  /** webVoucher img */
  readonly image: string;
  /** webvoucher label */
  readonly label: string;
  /** webVoucher short description */
  readonly description_short: string;
  /** webVoucher long description im html format */
  readonly description_long_html: string;
  /** has webVoucher preview */
  readonly has_preview: boolean;
  /** preview of the vewVoucher */
  readonly preview;
  /** webVoucher price*/
  readonly price: number;
}


export interface IContinueShoppingDialogData {
  itemConfig: IWebVoucherConfig;
  isInhOuseGroupOrder?: boolean;
}

interface IWebVoucherConfig {
  image?: string;
  label: string;
  price: number;
  count: number;
  isWebVoucher: boolean;
  displayPersonCount?: boolean;
  personCount?: number;
  isFreeAmount?: boolean;
  showDeliveryType: boolean;
  deliveryType: number;
}